import React from 'react';
import { Paper, Box, Typography } from '@mui/material';

const DetailTemplate = ({ children, title }) => {
  return (
    <Paper
      variant="outlined"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        my: { xs: 0.75, md: 2 },
        borderRadius: 2,
        overflow: 'hidden',
        maxWidth: '100%',
      }}
    >
      {/* 헤더: 좌측 포인트 바 + 연한 배경 */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          px: { xs: 1, md: 2 },
          py: { xs: 0.6, md: 1.2 },
          backgroundColor: '#f5f5f5',
          borderBottom: '1px solid #e0e0e0',
          borderLeft: '4px solid #1976d2',
        }}
      >
        <Typography
          variant="subtitle2"
          component="div"
          sx={{
            fontWeight: 700,
            color: '#1a1a1a',
            letterSpacing: 0.3,
            wordBreak: 'keep-all',
            fontSize: { xs: '0.8rem', md: '0.875rem' },
          }}
        >
          {title}
        </Typography>
      </Box>

      <Box sx={{ px: { xs: 1, md: 2 }, pt: { xs: 0.75, md: 1.5 }, pb: { xs: 1, md: 2 }, minWidth: 0 }}>
        {children}
      </Box>
    </Paper>
  );
};

export default DetailTemplate;
